import { render, staticRenderFns } from "./add-update-popup.vue?vue&type=template&id=0c72178d"
import script from "./add-update-popup.vue?vue&type=script&lang=js"
export * from "./add-update-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports